import axios from 'axios';

const BASE_URL = '/painel-api/api/verificacoes';

export const findAll = () => axios.get(BASE_URL);
